import React from "react";
import styled from "styled-components";
import { graphql, Link } from "gatsby";
import kebabCase from "lodash/kebabCase";

const TagExplorerWrapper = styled.div`
  position: fixed;
  right: 40px;
  top: 50%;
  height: 430px;
  width: 200px;
  @media (max-width: 1366px) {
    display: none;
  }
  & > a {
    display: block;
    margin: 0;
    transition: 300ms;
    &:hover {
      color: lightskyblue;
      cursor: pointer;
    }
  }
`;

const TagExplorer = ({ group }) => {
  console.log(group);
  return (
    <TagExplorerWrapper>
      <h4>태그별 보기</h4>
      <hr />
      {group.map((item) => (
        <Link to={`/tags/${kebabCase(item.tag)}/`}>
          #{item.tag} - {item.totalCount}
        </Link>
      ))}
    </TagExplorerWrapper>
  );
};

export default TagExplorer;

export const pageQuery = graphql`
  query {
    allMarkdownRemark {
      group(field: frontmatter___tags) {
        tag: fieldValue
        totalCount
      }
    }
  }
`;
